import { FormKey } from '../enums/formKey.enum';
import { FormData, SingleInputData } from '../interfaces/formData.interface';

const getInitialFormInputState = (key: FormKey): SingleInputData => {
  return {
    error: undefined,
    key: key,
    value: '',
  };
};

export const getInitialFormState = (): FormData => {
  const form: FormData = {};

  for (const key of Object.values(FormKey)) {
    form[key] = getInitialFormInputState(key);
  }

  return form;
};
